import type {
  RequestOptions,
  VueAuth,
  VueAuthCreateOptions,
} from '@websanova/vue-auth';
import ssoAuth from '@/config/sso';
import { refreshAuthSession } from '@/auth/useAuth';

interface ThisInterface extends VueAuthCreateOptions, VueAuth {}
interface AuthRequestOptions extends RequestOptions {
  headers?: Record<string, string>;
  status?: number;
}

type ResData = {
  access_token?: string;
  refresh_token?: string;
};
type DataKey = keyof ResData;

export default {
  request: function (
    this: ThisInterface,
    req: AuthRequestOptions,
    token: string,
  ) {
    if (req.url === this.options.refreshData.url) {
      req.data = {
        refresh_token: this.token(this.options.refreshTokenKey),
        grant_type: 'refresh_token',
        client_id: this.options.clientId,
        client_secret: this.options.clientSecret,
      };
    }
    this.drivers.http.setHeaders.call(this, req, {
      Authorization: `Bearer ${token}`,
    });
  },

  response: function (this: ThisInterface, res: AuthRequestOptions) {
    const data: ResData = res.data || {};

    if (this.drivers.http.invalidToken(res) || res.status === 400) {
      ssoAuth.logout({ auth: this });
    }

    // Store refresh_token if present
    this.token(
      this.options.refreshTokenKey,
      data[this.options.refreshTokenKey as DataKey],
    );

    const accessToken = data[this.options.tokenDefaultKey as DataKey];
    if (accessToken) {
      this.token(this.options.tokenDefaultKey, accessToken);
      refreshAuthSession();
    }

    return accessToken;
  },
};
